module.exports = __webpack_public_path__ + "static/media/Foodgiving.4c0033cb.png";